module.exports = __webpack_public_path__ + "static/img/LoganMartin.c369f98.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/LoganMartin.jpg
// module id = M9Av
// module chunks = 0